export default defineNuxtRouteMiddleware((to) => {
  // Пропускаем проверку для страниц login и index - они всегда доступны
  if (
    !to.name ||
    /^login___..$/.test(to.name.toString()) ||
    /^index___..$/.test(to.name.toString()) ||
    /^protocol-handler___/.test(to.name.toString()) ||
    /^admin-set-password___..$/.test(to.name.toString())
  ) {
    return;
  }

  // Получаем composable для работы с ролями
  const { hasPageAccess, loading } = useRoles();

  // Если ресурсы ещё не загружены, пропускаем проверку
  // (они загружаются в плагине init.client.ts при старте приложения)
  if (loading.value) {
    return;
  }

  const pageName = normalizePageName(to);

  if (!pageName) {
    return;
  }

  const hasAccess = hasPageAccess(pageName);

  // Если доступа нет, перенаправляем на индексную страницу
  if (!hasAccess) {
    return navigateTo('/');
  }
});
